import {ErrorCodeEnum} from "../types/cgreact-type-application";

/** 一个全局的CGReact异常类*/
export class CGReactPageException extends Error
{
    public errorCode: ErrorCodeEnum; //错误代码
    public errorExplain: string; //错误描述
    public errorMessage: string; //错误处理方案
    constructor(code: ErrorCodeEnum, explain?: string, message?: string)
    {
        let errorMap = {
            400: "请求参数错误",
            401: "没有访问权限",
            403: "服务器拒绝请求",
            404: "指定的页面地址不存在",
            499: "未知的服务错误",
            500: "服务器内部错误",
            501: "服务器不支持请求的功能"
        };
        let handleMap = {
            400: "请联系页面开发人员",
            401: "请登录后重试",
            403: "请与网站管理员联系",
            404: "请确定您的请求地址是否有误",
            499: "网络异常，稍后重试！",
            500: "请联系页面开发人员",
            501: "请与网站管理员联系"
        };
        explain = explain ? explain : errorMap[code]; //保障explian有值
        message = message ? message : handleMap[code]; //保障message有值
        super("错误" + code + "(" + explain + ") : " + message);
        this.errorCode = code;
        this.errorExplain = explain;
        this.errorMessage = message;
    }

    /** 获取错误码*/
    public getErrorCode(): number
    {
        return this.errorCode;
    }

    /** 获取错误描述*/
    public getErrorExplain(): string
    {
        return this.errorExplain;
    }

    /** 获取错误处理信息*/
    public getErrorMessage(): string
    {
        return this.errorMessage;
    }

    /** 调用静态函数抛出异常*/
    public static throw(code: ErrorCodeEnum, explain?: string, message?: string)
    {
        throw new CGReactPageException(code, explain, message);
    }
}
